import { Org } from 'api/Orgs/types';
import OrgModelsSettings from 'components/Dashboard/Orgs/Wizard/OrgModels/OrgModelsSettings/OrgModelsSettings';
import OrgModelsTransfer from 'components/Dashboard/Orgs/Wizard/OrgModels/OrgModelsTransfer/OrgModelsTransfer';

import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import React from 'react';

interface Props {
  org: Org;
}

const OrgModels: React.FC<Props> = ({ org }) => {
  const tabs: TabsProps['items'] = [ {
    key: 'transfer',
    label: 'Organization models',
    children: <OrgModelsTransfer org={org} />,
  }, {
    key: 'settings',
    label: 'Settings',
    children: <OrgModelsSettings org={org} />,
  } ];

  return <Tabs defaultActiveKey="transfer" items={tabs} type="line" destroyInactiveTabPane />;
};

export default OrgModels;
